'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["layout", "blockSize", "flexGrow"];
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import PropTypes from 'prop-types';
import { Component } from 'react';
import createTrap from 'reporting-ui-components/trap/createTrap';
import styled from 'styled-components';
import debounce from 'transmute/debounce';
import identity from 'transmute/identity';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  Receive,
  Raise
} = createTrap('Loading');
const DEBOUNCE_TIME = 200;
const Contents = styled.div.withConfig({
  displayName: "LoadingTrap__Contents",
  componentId: "sc-1m583kq-0"
})(["display:flex;flex-direction:column;", ";> *:not([data-test-id='reporting-loading-overlay']):not(.alert){flex-grow:1;}"], ({
  isLoadingWithOverlay
}) => isLoadingWithOverlay ? 'overflow: hidden;' : undefined);
export class LoadingBoundary extends Component {
  constructor() {
    super();
    this.state = {
      loading: true
    };
    this.handleRaise = debounce(DEBOUNCE_TIME, value => {
      if (!this._unmounted) {
        const lastState = this.state;
        this.setState(state => Object.assign({}, state, {
          loading: state.loading && value.length > 0
        }), () => {
          const {
            onLoaded
          } = this.props;
          const {
            loading
          } = this.state;
          if (!this._unmounted && !loading && lastState.loading) {
            onLoaded();
          }
        });
      }
    });
  }
  componentDidMount() {
    this.handleRaise([]);
  }
  componentWillUnmount() {
    this._unmounted = true;
  }
  render() {
    const {
      children,
      showOverlay
    } = this.props;
    const {
      loading
    } = this.state;
    const isLoadingWithOverlay = loading && showOverlay;
    const overlay = isLoadingWithOverlay ? /*#__PURE__*/_jsx(TFlex, {
      zIndex: 1000,
      position: "fixed",
      insetBlockStart: "0",
      insetBlockEnd: "0",
      insetInlineEnd: "0",
      insetInlineStart: "0",
      backgroundColor: "fill-surface-default",
      justifyContent: "center",
      "data-test-id": "reporting-loading-overlay",
      role: "presentation",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered",
        blockSize: "100%"
      })
    }) : null;
    return /*#__PURE__*/_jsx(Receive, {
      onRaise: this.handleRaise,
      children: /*#__PURE__*/_jsxs(Contents, {
        isLoadingWithOverlay: isLoadingWithOverlay,
        children: [overlay, children]
      })
    });
  }
}
LoadingBoundary.defaultProps = {
  onLoaded: identity,
  showOverlay: true
};
LoadingBoundary.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onLoaded: PropTypes.func,
  showOverlay: PropTypes.bool
};
export const RaiseLoading = _ref => {
  let {
      layout = 'centered',
      blockSize = '100%',
      flexGrow = 1
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Raise, {
    children: /*#__PURE__*/_jsx(LoadingSpinner, Object.assign({
      layout: layout,
      blockSize: blockSize,
      flexGrow: flexGrow
    }, props))
  });
};